import router from "@/router";
import store from '@/store'
import {treeToArr} from './useStructureConvert'

const whiteList = ['/index']


export const routerNext = (toPath) => {
    return new Promise(resolve => {
        let userInfo = store.state.userInfo

        if (!userInfo) {
            return false
        }

        if (userInfo.user_level === 1) {
            resolve(true)
            return false
        }

        if (store.state.menu.length > 0) {
            let _menu = store.state.menu
            let _item = _menu.find(item => item.path === toPath)
            if (_item || whiteList.includes(toPath)) {
                resolve(true)
            } else {
                router.replace('/404')
            }
        }
    })
}